import { MessageCircle } from "lucide-react";
import { business, waLink } from "../config/business";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "./shared";

// Foto personal: sustituir /images/alfonso.webp cuando el propietario la suba (hasta entonces, emblema de la marca)
const PHOTO = "/images/alfonso.webp";

const AboutMe = () => {
  const { t } = useLanguage();

  return (
    <section id="about-me" data-testid="about-me-section" className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
      <Reveal>
        <div className="card-elevated relative overflow-hidden rounded-3xl p-7 sm:p-10 lg:p-12">
          <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-amber-400/10 blur-3xl" />
          <div className="relative grid items-center gap-8 md:grid-cols-[auto_1fr] md:gap-12">
            <div className="relative mx-auto h-44 w-44 sm:h-56 sm:w-56 md:mx-0">
              <div className="absolute -inset-2 rounded-full bg-gradient-to-br from-yellow-300 via-amber-400 to-amber-600 opacity-70 blur-md" />
              <img
                data-testid="about-me-photo"
                src={PHOTO}
                onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/images/logo.webp"; }}
                alt="Alfonso, UNLockSmiths locksmith in Edinburgh"
                className="relative h-full w-full rounded-full border-4 border-[#0A1526] object-cover shadow-[0_24px_50px_-20px_rgba(0,0,0,0.8)]"
              />
            </div>
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-amber-400/90">{t.aboutMe.label}</p>
              <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.03em] leading-[1.1]">{t.aboutMe.title}</h2>
              <p data-testid="about-me-text" className="mt-5 max-w-2xl text-lg sm:text-xl leading-relaxed text-slate-200">
                “{t.aboutMe.quote}”
              </p>
              <a
                data-testid="about-me-whatsapp-cta"
                href={waLink(t.hero.waMessage)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-wa mt-8 rounded-2xl px-7 py-4 text-base"
              >
                <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
                {t.hero.whatsapp}
              </a>
              <p className="mt-4 font-mono text-sm text-slate-500">WhatsApp: {business.phoneDisplay}</p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default AboutMe;
